module.exports = __webpack_public_path__ + "static/q18-26e93307ad8278055fa06cacf3ea8990.png";